import { P2GText, P2GLink, P2GButton, P2GCardContent, P2GCard, P2GStack } from '@parcel2go/core-ui';
import { useTranslation, Trans } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export default function NeedHelp({ adviceUrl }: { adviceUrl?: string }) {
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  return (
    <P2GCard sx={{ height: '100%' }} variant="outlined">
      <P2GCardContent sx={{ height: '100%' }}>
        <P2GStack sx={{ height: '100%' }} spacing={2} justifyContent="space-between">
          <P2GText>
            <Trans
              t={t}
              i18nKey="RESULT_INFORMATION_CARDS_HELP_ADVICE_TITLE"
              defaults="If you’re having any issues with your delivery click below."
            />
          </P2GText>
          <P2GLink href={adviceUrl} target="_blank" relationship="noopener noreferrer" underline="none">
            <P2GButton variant="tertiary">
              <Trans t={t} i18nKey="RESULT_INFORMATION_CARDS_HELP_ADVICE_BUTTON" defaults="Help and Advice" />
            </P2GButton>
          </P2GLink>
        </P2GStack>
      </P2GCardContent>
    </P2GCard>
  );
}
